module.exports = __webpack_public_path__ + "static/faq-banner-37f81da79e1e718b8fa37cf42666b52e.png";